import { render, staticRenderFns } from "./CitationPreviewModal.vue?vue&type=template&id=1cd9d3e8&scoped=true"
import script from "./CitationPreviewModal.vue?vue&type=script&lang=js"
export * from "./CitationPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./CitationPreviewModal.vue?vue&type=style&index=0&id=1cd9d3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd9d3e8",
  null
  
)

export default component.exports